import styled from 'styled-components';
import { Drawer } from '@material-ui/core';
import { COLORS } from 'constants/design';

export const DrawerContainer = styled(Drawer)`
  .MuiDrawer-paper {
    overflow-y: visible;
  }
  .MuiTimelineOppositeContent-root {
    flex: unset;
    padding: 0;
  }
  .MuiTimelineDot-root {
    color: rgba(84, 147, 189, 1);
    background-color: rgba(212, 236, 255, 1);
    box-shadow: unset;
    width: 12px;
    height: 12px;
  }
  .divider {
    width: 100%;
    background: ${COLORS.DEVIDER_GREY};
    height: 2px;
    margin-bottom: 10px;
  }
  .titleConatainer {
    height: 64px;
    padding-left: 24px;
    padding-top: 23px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
  }
  .title {
    color: ${COLORS.TEXT_BLACK};
    text-align: left;
    font-size: 15px;
    font-family: Roboto;
    font-weight: bold;
    letter-spacing: 0px;
    text-transform: uppercase;
    opacity: 1;
  }
  .actions {
    padding: 10px;
  }

  .action-buttons-container {
    padding: 0 10px;
  }

  .saveButton,
  .cancelButton {
    width: 126px;
    height: 36px;
  }

  .disabledSaveButton {
    width: 126px;
    height: 36px;
    background: #dddddd 0% 0% no-repeat padding-box;
    border: 1px solid #dddddd;
    color: #333e48;
    text-transform: none;
    cursor: not-allowed;
  }
`;
